// Magic Webpack variable that sets path at runtime so we ensure asserts are served from CDN.
// eslint-disable-next-line
__webpack_public_path__ = window.resourcePath;
